export default __webpack_public_path__ + "static/media/kloudspot.287617c8.png";